<mat-form-field style="width: 100%">
  <mat-label>Customer</mat-label>
  <input
    #input
    type="text"
    placeholder="Choose a Customer"
    matInput
    [class.invalid]="invalid()"
    [disabled]="disabled()"
    [readonly]="readonly()"
    [matAutocomplete]="customerAuto"
    (blur)="touched.set(true)"
    [value]="value() ? $safeNavigationMigration(getCustomer?.data()?.customer?.name) : value()"
    (input)="inputValue.set($event.target.value)"
  />
  <mat-autocomplete
    #customerAuto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="value.set($event.option.value.id)"
  >
    @for (option of filteredOptions.data()?.customers; track option.id) {
      <mat-option [value]="option">{{ option.name }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
@if (invalid()) {
  <div
    class="error-messages"
    role="alert"
  >
    @for (error of errors(); track error) {
      <span class="error">{{ error.message }}</span>
    }
  </div>
}
@if (disabled() && disabledReasons().length > 0) {
  <div class="disabled-reasons">
    @for (reason of disabledReasons(); track reason) {
      <span>{{ reason.message }}</span>
    }
  </div>
}
<!-- <code>Model Value: {{ value() }}</code> -->
